// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { useUserContext } from '../../../context/UserContext';
import { NoSsr, Skeleton, useMediaQuery } from '../../../lib/base';
import type { Theme } from '../../../theme/Theme';
import { type FormatTimeOptions, formatTime } from '../../../utils';

interface Props {
  readonly time: number;
  readonly options?: FormatTimeOptions;
  readonly dontUseTimezone?: boolean;
}
export default function Time({ time: timeSeconds, options, dontUseTimezone }: Props): React.ReactElement {
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
  const optionsIn = {
    ...options,
    removeDayOfWeek: options?.removeDayOfWeek ?? xs,
    shortenDayOfMonth: options?.shortenDayOfMonth ?? xs,
    timezone: dontUseTimezone ? undefined : useUserContext().timezone,
  };
  const timeValue = formatTime(timeSeconds, optionsIn);
  const value = <div>{timeValue}</div>;
  if (dontUseTimezone === false || dontUseTimezone === undefined) {
    return value;
  }
  const inputYearDifferentFromCurrentYear = new Date(timeSeconds * 1000).getFullYear() !== new Date().getFullYear();
  const yearExtraLength = options?.year === true || inputYearDifferentFromCurrentYear ? 40 : 0;
  const timeExtraLength = options?.time === true ? 70 : 0;

  return <NoSsr fallback={<Skeleton variant="text" width={73 + timeExtraLength + yearExtraLength} />}>{value}</NoSsr>;
}
